// Histórico de alterações e comprovantes da confirmação de vagas / cadastro reserva (PGPP-756).

export interface HistoricoConfirmacaoVaga {
  id: number;
  dataAcao: string;
  acao: 'I' | 'U';
  entidade: string;
  registro: string | null;
  campo: string | null;
  valorAnterior: string | null;
  valorNovo: string | null;
  usuarioNome: string | null;
  ipOrigem: string | null;
}

export type TipoComprovanteConfirmacao = 'CV' | 'CR' | 'CA';

export interface ComprovanteConfirmacao {
  id: number;
  tipo: TipoComprovanteConfirmacao;
  dataEmissao: string;
  usuarioNome: string | null;
  /** JSON (ComprovanteConteudo) só na consulta individual. */
  conteudo?: string | null;
}

/** Conteúdo congelado do comprovante, como o back grava em tl_comprovante_confirmacao. */
export interface ComprovanteConteudo {
  tipo: TipoComprovanteConfirmacao;
  ciclo: { id: number; numeroCiclo: number; anoCiclo: number; programa: string | null };
  /** Nulo na confirmação estadual (aprimoramento pelo gestor estadual). */
  municipio: { id: string; nome: string; siglaUf: string } | null;
  uf?: { id: string; siglaUf: string; nome: string } | null;
  gestor: string | null;
  dataConfirmacao: string | null;
  totalVagasConfirmadas: number;
  resumo: { modalidade: string; total: number }[];
  vagas: {
    modalidade: string | null;
    nuIdVaga: string;
    nuIne: string | null;
    nomeEquipe: string | null;
    tipoEquipe: string | null;
    coCnes: string | null;
    nomeEstabelecimento: string | null;
  }[];
  cadastroReserva: { tipoEquipe: string; confirmado: boolean | null }[];
  /** Só no aprimoramento (CA): documento assinado anexado na confirmação. */
  nuRefDocumento?: string | null;
}

export const TIPO_COMPROVANTE_LABEL: Record<TipoComprovanteConfirmacao, string> = {
  CV: 'Confirmação de vagas',
  CR: 'Cadastro reserva',
  CA: 'Confirmação por aprimoramento',
};

/** Escopo da consulta nacional: município tem precedência; sem município, a UF (sigla). */
export interface EscopoHistoricoNacional {
  cicloId: number;
  coMunicipioIbge?: string | null;
  sgUf?: string | null;
}

export const ACAO_HISTORICO_LABEL: Record<'I' | 'U', string> = {
  I: 'Inclusão',
  U: 'Alteração',
};
